export default __webpack_public_path__ + "static/media/honestpay.62e0e45a.svg";